import { render, staticRenderFns } from "./CustomDashboardComponent.vue?vue&type=template&id=0da72fb4&scoped=true&"
import script from "./CustomDashboardComponent.vue?vue&type=script&lang=ts&"
export * from "./CustomDashboardComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da72fb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
